










































import { computed, defineComponent } from '@vue/composition-api';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { useTabbedNav } from '@front-app/components/tabs/useTabbedNav';
import { Routes } from '@front-app/constants/routes';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { GroupsStore } from '@front-app/store/singletons/Groups';

enum LearningProgramsTabs {
	ALL_PROGRAMS = 'all_programs',
	MANAGE_SURVEYS = 'manage_surveys',
}

const ROUTE_TO_TAB: {[key: string]: string} = {
	[Routes.GROUP_ADMIN_LEARNING_PROGRAMS_ALL_PROGRAMS]: LearningProgramsTabs.ALL_PROGRAMS,
	[Routes.GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS]: LearningProgramsTabs.MANAGE_SURVEYS,
};

const TAB_BUTTONS: ButtonNavButton[] = [
	{
		key: LearningProgramsTabs.ALL_PROGRAMS,
		id: LearningProgramsTabs.ALL_PROGRAMS,
		label: 'lms.admin.all-programs',
		to: { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_ALL_PROGRAMS },
	},
	{
		key: LearningProgramsTabs.MANAGE_SURVEYS,
		id: LearningProgramsTabs.MANAGE_SURVEYS,
		label: 'lms.admin.manage-surveys',
		to: { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS },
	},
];

export default defineComponent({
	components: {
		ColumnHeader,
		ErrorCard,
		TabbedNav,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const {
			hasAnyLearningProgramsAccess,
			hasAllLearningProgramsManagementAccess: canViewMultipleTabs,
		} = useAdminAccess(group);

		// Tabs
		const {
			tabButtons,
			currentTabKey,
		} = useTabbedNav(ctx, TAB_BUTTONS, ROUTE_TO_TAB);
		// END Tabs

		return {
			// Permissions
			hasAnyLearningProgramsAccess, // User has _some access_
			canViewMultipleTabs,
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
			// Tabs
			tabButtons,
			currentTabKey,
		};
	},
});
